module.exports = __webpack_public_path__ + "img/code.37c4e6bc.png";